module.exports = __webpack_public_path__ + "img/078-belize.ec7cadfe.svg";